import { Icon, IconButton, styled } from '@mui/material'
import { useIntl } from 'react-intl'
import { useRedirect } from '../../../hooks'
import { ROUTE_MAINPAGE } from '../../../routes/constants/routeConstants'

const LogoButton = styled(IconButton)({
  padding: 0
})

interface TopBarLogoProps {
  isMobile?: boolean
}

export const TopBarLogo = ({ isMobile = false }: TopBarLogoProps) => {
  const logo = isMobile ? 'logo_mobile.png' : 'logo.png'
  const { formatMessage } = useIntl()
  const altText = formatMessage({ id: 'logo' })
  const { redirect } = useRedirect()

  return (
    <LogoButton
      edge="start"
      color="inherit"
      aria-label="menu"
      onClick={() => redirect(ROUTE_MAINPAGE)}
    >
      <Icon
        component={() => (
          <img alt={altText} src={'/assets/' + logo} title={altText} />
        )}
      />
    </LogoButton>
  )
}
